import { MioGruppoStudioDTO } from 'src/app/model/newModel';
import { Component, AfterViewInit, Input } from '@angular/core';

import * as Prism from 'prismjs';
import { Router } from '@angular/router';
import { GoToModel } from '../../model/newModel';

@Component({
  selector: 'app-accordion-miei-gruppi-studio',
  templateUrl: './accordion-miei-gruppi-studio.component.html',
  styleUrls: ['./accordion-miei-gruppi-studio.component.css'],
})
export class MieiGruppiStudioAccordionComponent implements AfterViewInit {
  @Input() listAccordion: MioGruppoStudioDTO[] = [];
  @Input() arrow = true;
  constructor(public router: Router) {}
  /**
   * @method ngAfterViewInit
   */
  ngAfterViewInit() {
    Prism.highlightAll();
  }

  goToGruppoStudioDetail(id: number) {
    const goBack = new GoToModel();
    goBack.url = 'dashboard-instructor';
    this.router.navigate(['/a-gruppo-studio/dettaglio'], {
      queryParams: { idGruppoStudio: id, goBack: JSON.stringify(goBack) },
    });
  }
}
